module.exports = __webpack_public_path__ + "img/sc.bc69cb78.png";